import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import DynamicTable from '../../DynamicTable';
import * as styled from '../../../molecules/table/CopyrightCheckerDossierTableRow.style';
function CopyrightCheckerPhotoOverviewTable({ data = [], loading = false, }) {
    const { t } = useTranslation();
    return (_jsx(DynamicTable, { id: "photos", data: data, loading: loading, 
        // onRowClick={photo => Inertia.visit(`/inbreuken/afbeeldingen/${photo.id}`)}
        noData: () => t('copyright_checker.no_results'), config: [
            {
                property: 'temporary_url',
                columnName: 'copyright_checker.photo.image',
                align: 'left',
                visible: true,
                transform: (temporary_url) => (_jsx(styled.StyledLink, { href: temporary_url, target: "_blank", rel: "noreferrer", children: _jsx(styled.ImagePreview, { loading: "lazy", decoding: "async", src: temporary_url }) })),
            },
            {
                property: 'original_file_name',
                columnName: 'copyright_checker.photo.original_file_name',
                align: 'left',
                visible: true,
            },
            {
                property: 'detections_count',
                columnName: 'copyright_checker.photo.detection_count',
                align: 'left',
                visible: true,
            },
            {
                property: 'full_detections_count',
                columnName: 'copyright_checker.photo.full_detections_count',
                align: 'left',
                visible: true,
            },
            {
                property: 'embedded_detections_count',
                columnName: 'copyright_checker.photo.embedded_detections_count',
                align: 'left',
                visible: true,
            },
            {
                property: 'created_at',
                columnName: 'copyright_checker.photo.created_at',
                align: 'left',
                visible: true,
                noWrap: true,
                transform: value => {
                    return typeof value === 'string'
                        ? new Date(value).toLocaleDateString('nl-nl', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric',
                        })
                        : value;
                },
            },
        ] }));
}
export default memo(CopyrightCheckerPhotoOverviewTable);
